/** @format */

import React from "react";
import StepOne from "./Steps/StepOne";
import StepFive from "./Steps/StepFive";
import StepFour from "./Steps/StepFour";
import StepThree from "./Steps/StepThree";
import StepTwo from "./Steps/StepTwo";
import CustomButton from "../UI/CustomButton/inedx";

const MobileCalculator = ({
  data,
  setData,
  calculatorType,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
  isCalculate,
  setIsCalculate,
  isEditMode,
  setIsEditMode,
  isWagePerHour,
  handleNextStep,
  isStep5,
}) => {
  const renderSteps = [
    <>
      <StepOne
        data={data}
        setData={setData}
        calculatorType={calculatorType}
        handleBlur={handleBlur}
        dataError={dataError}
        setDataError={setDataError}
        handleEnter={handleEnter}
      />
      <div className="horizontal" />
    </>,
    isStep5 ? (
      <>
        <StepFive
          isCalculate={isCalculate}
          setIsCalculate={setIsCalculate}
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
          isWagePerHour={isWagePerHour}
          isStep2
        />
        <div className="horizontal" />
      </>
    ) : (
      <>
        <StepTwo
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
        />
        <div className="horizontal" />
      </>
    ),
    isStep5 || isWagePerHour ? (
      <>
        <StepFour
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
          isStep3
        />
        <div className="horizontal" />
      </>
    ) : (
      <>
        <StepThree
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
        />
        <div className="horizontal" />
      </>
    ),
    !isStep5 && !isWagePerHour && (
      <>
        <StepFour
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
          isStep3={false}
        />
        <div className="horizontal" />
      </>
    ),
    !isStep5 && (
      <>
        <StepFive
          isCalculate={isCalculate}
          setIsCalculate={setIsCalculate}
          data={data}
          setData={setData}
          calculatorType={calculatorType}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          handleBlur={handleBlur}
          dataError={dataError}
          setDataError={setDataError}
          handleEnter={handleEnter}
          isWagePerHour={isWagePerHour}
          isStep2={false}
        />
      </>
    ),
  ];
  return (
    <div className="mobile_view_steps_wrapper">
      {renderSteps?.map((step, index) => (
        <div key={index} className="mobileViewSteps">
          {step}
        </div>
      ))}
      <div className="mobile_next-button">
        <CustomButton
          onClick={handleNextStep}
          size="large"
          className="next-button"
        >
          Calculate
        </CustomButton>
      </div>
    </div>
  );
};

export default MobileCalculator;
